const updateItems = [
  {
    date: '2026-07-31',
    title: '《三体：大史》全集上线',
    desc: '国产科幻巨制《三体》衍生剧《大史》全12集一次性放出，史强前传故事引爆全网讨论。',
    tag: '最新上线',
  },
  {
    date: '2026-07-31',
    title: '《怪奇物语》最终季上线',
    desc: 'Netflix王牌剧集《怪奇物语》第五季回归，霍金斯小镇的终极决战正式拉开帷幕。',
    tag: '海外热播',
  },
  {
    date: '2026-07-30',
    title: '《长安十二时辰》4K修复版',
    desc: '经典国产古装悬疑剧4K修复版独家上线，雷佳音易烊千玺原声再现盛唐危机。',
    tag: '经典修复',
  },
  {
    date: '2026-07-30',
    title: '暑期档新片《封神第三部》全网首播',
    desc: '乌尔善导演封神系列终章上线，姜子牙率领众神决战朝歌，特效场面震撼人心。',
    tag: '院线同步',
  },
  {
    date: '2026-07-29',
    title: '日剧《重启人生》加长版上线',
    desc: '豆瓣9.4分神作加长版独家登陆四虎，新增30分钟未播出内容，安藤樱演技炸裂。',
    tag: '高分推荐',
  },
  {
    date: '2026-07-29',
    title: '动漫《葬送的芙莉莲》第二季',
    desc: '治愈系神作第二季温情回归，芙莉莲继续踏上理解人类的漫长旅程。',
    tag: '动漫更新',
  },
  {
    date: '2026-07-28',
    title: '《舞男》剧场版特别篇上线',
    desc: '人气漫画改编剧场版动画，超清画质完美呈现细腻画风和感人故事。',
    tag: '剧场版',
  },
  {
    date: '2026-07-28',
    title: '综艺《这就是街舞》第七季',
    desc: '全新导师阵容集结，全球街舞大神齐聚，燃炸舞台的巅峰对决强势回归。',
    tag: '综艺热播',
  },
  {
    date: '2026-07-27',
    title: '经典港片修复计划：首批50部上线',
    desc: '四虎影视大全启动经典港片修复计划，周星驰、成龙、周润发代表作高清回归。',
    tag: '特别企划',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-primary-500/10 text-primary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-flashlight-fill text-xs"></i>
            实时更新
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm">影视快讯每日同步，精彩不错过</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300/50"></div>

          <div className="space-y-5">
            {updateItems.map((item, idx) => (
              <div key={idx} className="relative pl-10 md:pl-14">
                <div className="absolute left-2.5 md:left-4.5 top-1.5 w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100 z-10"></div>
                <div className="bg-background-200/70 rounded-xl border border-background-300/40 p-4 hover:border-background-400/60 transition-all cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-2">
                    <span className="text-foreground-500 text-xs">{item.date}</span>
                    <span className="inline-flex px-2 py-0.5 rounded-md bg-primary-500/10 text-primary-400 text-xs font-medium whitespace-nowrap w-fit">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-1">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-xs md:text-sm">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}